import qs from 'qs';

const getParsedUrlParams = ({ hash, search }) => {
  const hashQuery = hash.substring(1);
  const hashParsed = qs.parse(hashQuery);
  const { a_aid: hashSource, p: hashPromo, s: hashSourceShort } = hashParsed;

  const query = search.substring(1);
  const parsed = qs.parse(query);
  const {
    promo,
    p: queryPromoShort,
    s: querySourceShort,
    utm_source: utmSource,
    ref,
  } = parsed;

  const foundPromo = promo || hashPromo || queryPromoShort;
  const foundSource =
    utmSource || ref || hashSource || hashSourceShort || querySourceShort;

  return { foundPromo, foundSource };
};

export default getParsedUrlParams;
